export default function FertilityIcon({ color = "#053137", size = 36, rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M22.7207 26.1622C19.5224 26.6585 16.9913 27.2432 16.9913 27.2432C16.9913 27.2432 16.9103 26.9255 17.1283 23.797C17.3463 20.6685 18.7626 17.7523 21.0657 15.6898C23.3687 13.6273 26.3699 12.5876 29.4089 12.7994L35.1383 13.1986L35.0013 15.1646C34.7834 18.2931 33.367 21.2093 31.064 23.2718C28.7609 25.3342 25.919 25.6659 22.7207 26.1622Z"
        fill={color}
      />
      <path
        d="M10.4922 21.8579L15.7384 23.4692L16.2763 21.7177C17.1323 18.9305 16.8478 15.918 15.4854 13.3429C14.123 10.7677 11.7943 8.84091 9.01152 7.98625L3.76533 6.375L3.2274 8.12649C2.3714 10.9136 2.65589 13.9261 4.01831 16.5013C5.38072 19.0764 7.70946 21.0032 10.4922 21.8579Z"
        fill={color}
      />
      <path
        d="M27.2534 27.6081C24.837 29.7887 21.5815 31.125 18.0004 31.125C11.4539 31.125 5.99564 26.6593 4.76172 20.7332"
        stroke={color}
        stroke-width="1.25"
      />
      <path
        d="M11.8125 6.68586C13.6661 5.76822 15.7699 5.25 18 5.25C22.8748 5.25 27.1461 7.7261 29.5192 11.4375"
        stroke={color}
        stroke-width="1.25"
      />
    </svg>
  );
}
